'use client';

import React, { useEffect, useRef } from 'react';


const clientLogos = [
  { name: 'Stellantis',        industry: 'Automotive',    initials: 'STE' },
  { name: 'Tyson Foods',       industry: 'Food & Bev.',   initials: 'TYS' },
  { name: 'Caterpillar',       industry: 'Heavy Ind.',    initials: 'CAT' },
  { name: 'Ford Motor',        industry: 'Automotive',    initials: 'FRD' },
  { name: 'Molson Coors',      industry: 'Food & Bev.',   initials: 'MC'  },
  { name: 'John Deere',        industry: 'Heavy Ind.',    initials: 'JD'  },
  { name: 'GM Supplier',       industry: 'Automotive',    initials: 'GMS' },
  { name: 'Kraft Heinz',       industry: 'Food & Bev.',   initials: 'KHC' },
];

const testimonials = [
  {
    quote: "The palletizing cell paid back capex in 14 months. Our operations director stopped asking questions after month six.",
    author: "Marcus Hollenbeck",
    title: "VP Operations",
    company: "Caterpillar Tier-1 Supplier",
    oee: "+18% OEE",
  },
  {
    quote: "Arc welding repeatability at ±0.05 mm eliminated the rework loop that was killing our line throughput.",
    author: "Priya Nandakumar",
    title: "Automation Engineering Lead",
    company: "Stellantis Chassis Plant",
    oee: "+22% throughput",
  },
  {
    quote: "Vision inspection caught a casting defect class we hadn\'t seen in three years. Caught it on day one of deployment.",
    author: "Derek Szymanski",
    title: "Quality Manager",
    company: "John Deere Component Works",
    oee: "0 escapes / 6 mo",
  },
];

export default function TrustSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef?.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-up').forEach((el, i) => {
              setTimeout(() => el.classList.add('visible'), i * 80);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    observer?.observe(section);
    return () => observer?.disconnect();
  }, []);

  return null;
}